let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Eq1b")).then(() => parcelRequire('cHwqN'));